




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { snackModule, routerModule, authModule } from '@/store';
import { RouteData } from '@/api/Wordpress';
import FooterCta from '@/components/frontend/FooterCta.vue';

@Component({
  components: { FooterCta },
})
export default class extends Vue {
  page: RouteData | null = null;

  get title() {
    if (!this.page) {
      return;
    }
    return this.page.title.rendered;
  }

  get content() {
    if (!this.page) {
      return;
    }
    return this.page.content.rendered;
  }

  get featuredImage() {
    if (!this.page || !this.page.featured_image_sizes) {
      return;
    }
    return this.page.featured_image_sizes;
  }

  get acf() {
    if (!this.page) {
      return;
    }
    return this.page.acf;
  }

  async mounted() {
    try {
      this.page = await routerModule.getPage(this.$route.path);
      if (this.title) {
        const title = this.title + ' - Hobart Airport Parking';
        const titleElement = document.getElementsByTagName('title')[0];
        if (titleElement) {
          titleElement.innerHTML = title;
        } else {
          document.title = title;
        }

        authModule.trackPageview({
          gtag: this.$gtag,
          route: this.$route,
          pageTitle: decodeURI(this.title),
        });
      }
    } catch (err) {
      // Not found
      snackModule.showSnackbar('Page not found');
    }
  }
}
